import React from 'react'
import { IconPropsType } from '../types'

const ArrowLeftIcon = ({ className }: IconPropsType) => {
  return (
    <svg
      width='30'
      height='31'
      className={className}
      viewBox='0 0 30 31'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M25 14.25H9.7875L16.775 7.2625L15 5.5L5 15.5L15 25.5L16.7625 23.7375L9.7875 16.75H25V14.25Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default ArrowLeftIcon
